(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FrequentlyAskedQuestionStateHistoryDeleteController',FrequentlyAskedQuestionStateHistoryDeleteController);

    FrequentlyAskedQuestionStateHistoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'FrequentlyAskedQuestionStateHistory'];

    function FrequentlyAskedQuestionStateHistoryDeleteController($uibModalInstance, entity, FrequentlyAskedQuestionStateHistory) {
        var vm = this;

        vm.frequentlyAskedQuestionStateHistory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FrequentlyAskedQuestionStateHistory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
